module.exports = __webpack_public_path__ + "img/handheld_idcard.d8b30553.png";